import React, { useState , useEffect} from 'react'
import SelectSearch from "react-select-search";
import './CustomSearch.css'
import 'react-select-search/style.css'
import { useRef } from "react";
function CustomSearch({addTest , tests , availableTests}) {
    const [test , setTest] = useState();
    
    const searchInput = useRef();
    let testList = availableTests.map((test,index) => ({
        name:test , value:index+1
    }));
    const options = [
    {
      type: "group",
      name: "Subtests",
      items: testList
    }
  ];
  const handleChange = (...args) => {
    setTest(args[1]);
    let add = true;
    tests.map((test) => {
      if(test.name === args[1].name){
          add=false;
      }
    })
  
  if(add){
      addTest(args[1]);
    }
  };
  const handleFilter = (items) => {
    return (searchValue) => {
      if (searchValue.length === 0) {
        return options;
      }
      const updatedItems = items.map((list) => {
        const newItems = list.items.filter((item) => {
          return item.name.toLowerCase().includes(searchValue.toLowerCase());
        });
        return { ...list, items: newItems };
      });
      return updatedItems;
    };
  };
  return (
    <div className="custom">
      <SelectSearch
        ref={searchInput}
        options={options}
        filterOptions={handleFilter}
        inputValue={test}
        name="Tests"
        placeholder="Choose a subtest"
        search
        onChange={handleChange}
      />
    </div>
  );
  
}
export default CustomSearch